export default class AppConstants {
  static LS_USER_LANGUAGE = "userLanguage";
}
